import React, { useContext, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { useRouteMatch } from "react-router-dom";

import { UserCard } from "widgets/datadisplay";
import { Link } from "widgets/navigation";

import { SpaceContext } from "@/container/feed";

import styles from "./mention.css";

Mention.propTypes = {
  node: PropTypes.object,
  teamId: PropTypes.string,
  innerRef: PropTypes.any,
  readOnly: PropTypes.bool
};

export function Mention(props) {
  const { node, teamId, readOnly = true, innerRef = {} } = props;
  const match = useRouteMatch(`/space/:teamId/channel/:mediumId`);
  const { spaceRoute } = useContext(SpaceContext);

  useImperativeHandle(innerRef, () => {
    return {
      getData: () => {
        return {
          Id: node.Id,
          Name: node.Name,
          Kind: node.Kind,
          Type: node.Type
        };
      }
    };
  });

  if (
    node.Type === "Channel" &&
    node.Id !== match?.params?.mediumId &&
    readOnly
  ) {
    return (
      <Link href={`/view/${spaceRoute}/${teamId}/channel/${node.Id}`}>
        {node.Name}
      </Link>
    );
  }

  if (node.Kind === "User") {
    return (
      <UserCard userId={node?.Id} name={node?.Name}>
        <span className={styles.linkText}>{node.Name}</span>
      </UserCard>
    );
  }
  return <span className={styles.linkText}>{node.Name}</span>;
}
